var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0359 42.0289L30.0359 42.0212M36.0215 19.5173L36.0234 22.5173C36.0276 29.1173 30.6311 34.5208 24.0311 34.525M24.0311 34.525C17.4311 34.5292 12.0276 29.1327 12.0234 22.5327L12.0215 19.5327M24.0311 34.525L24.0359 42.025",
    stroke: "red",
    strokeWidth: 3.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0281 30.0249C23.0382 30.0232 22.0586 29.8227 21.1477 29.4351C20.2367 29.0476 19.4129 28.481 18.7251 27.7689C17.3172 26.3508 16.5259 24.4343 16.5233 22.436L16.5166 12.0297C16.5121 11.0437 16.7029 10.0666 17.0778 9.15469C17.4528 8.24277 18.0046 7.4141 18.7013 6.71645C19.3981 6.01879 20.226 5.46596 21.1375 5.08983C22.0489 4.71369 23.0258 4.5217 24.0118 4.52491C28.2174 4.52221 31.5139 7.81447 31.5166 12.0201L31.5233 22.4263C31.526 26.6132 28.1634 30.0223 24.0281 30.0249Z",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopRecord);
export default __webpack_public_path__ + "static/media/stopRecord.db6e896188b967521d2cf6ee16153bb8.svg";
export { ForwardRef as ReactComponent };